const CALENDLY_URL = "https://calendly.com/goldmediastudio/30min?primary_color=d3c4a8";
const CSS_HREF = "https://assets.calendly.com/assets/external/widget.css";
const JS_SRC = "https://assets.calendly.com/assets/external/widget.js";

export const ensureCalendly = () =>
  new Promise((resolve) => {
    if (window.Calendly && window.Calendly.initPopupWidget) return resolve(true);

    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CSS_HREF;
      document.head.appendChild(link);
    }

    let script = document.querySelector(`script[src="${JS_SRC}"]`);
    const onReady = () => {
      const start = Date.now();
      const t = setInterval(() => {
        if (window.Calendly && window.Calendly.initPopupWidget) {
          clearInterval(t);
          resolve(true);
        } else if (Date.now() - start > 6000) {
          clearInterval(t);
          resolve(false);
        }
      }, 60);
    };

    if (script) {
      script.addEventListener("load", onReady);
      onReady();
    } else {
      script = document.createElement("script");
      script.src = JS_SRC;
      script.async = true;
      script.addEventListener("load", onReady);
      script.addEventListener("error", () => resolve(false));
      document.body.appendChild(script);
    }
  });

export const openCalendly = async (e) => {
  if (e && e.preventDefault) e.preventDefault();
  const ready = await ensureCalendly();
  if (ready && window.Calendly) {
    window.Calendly.initPopupWidget({ url: CALENDLY_URL });
  } else {
    window.open(CALENDLY_URL, "_blank", "noopener");
  }
};
